import React, {useEffect, useState} from "react";
import { motion } from "framer-motion";
import Breadcrumb from "../Components/Breadcrumb";
import ScaleCustomerCommunication from "../Components/ScaleCustomerCommunication";
import ProblemSolution from "../Components/ProblemSolutionSection";
import Cta from "../Components/Cta";
import engineIcon from "../Images/onbbits-icon.png";
import storyIcon from "../Images/onbbits-story-icon.png";
import SchemaMarkup from '../Components/SchemaMarkup';
import OrganizationSchema from "../Schema/OrganizationSchema";
import AboutPageSchema from "../Schema/AboutPageSchema";
import BreadcrumbSchema from "../Schema/BreadcrumbSchema";

const About=()=>{
   const leftVariant = {
  hidden: {
    opacity: 0,
    x: -120,
  },
  visible: {
    opacity: 1,
    x: 0,
    transition: {
      staggerChildren: 0.22,
      delayChildren: 0.15,
    },
  },
};

const child = {
  hidden: {
    opacity: 0,
    y: 50,
    scale: 0.96,
    filter: "blur(8px)",
  },
  visible: {
    opacity: 1,
    y: 0,
    scale: 1,
    filter: "blur(0px)",
    transition: {
      duration: .8,
      ease: [0.22,1,0.36,1],
    },
  },
};

const rightVariant = {
  hidden: {
    opacity: 0,
    x: 120,
    rotateY: 30,
    scale: .82,
  },
  visible: {
    opacity: 1,
    x: 0,
    rotateY: 0,
    scale: 1,
    transition: {
      duration: 1,
      ease: [0.22,1,0.36,1],
    },
  },
};

const imageVariant = {
  hidden: {
    opacity: 0,
    x: -80,
    scale: 0.92,
    filter: "blur(12px)",
  },
  visible: {
    opacity: 1,
    x: 0,
    scale: 1,
    filter: "blur(0px)",
    transition: {
      duration: 0.9,
      ease: [0.22, 1, 0.36, 1],
    },
  },
};

const textContainer = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.18,
      delayChildren: 0.2,
    },
  },
};

const textItem = {
  hidden: {
    opacity: 0,
    y: 35,
    filter: "blur(8px)",
  },
  visible: {
    opacity: 1,
    y: 0,
    filter: "blur(0px)",
    transition: {
      duration: 0.7,
      ease: [0.22, 1, 0.36, 1],
    },
  },
};

const [beamLength, setBeamLength] = useState(280);

useEffect(() => {
  const updateBeamLength = () => {
    const width = window.innerWidth;

    if (width <= 576) {
      setBeamLength(130);
    } else if (width <= 768) {
      setBeamLength(260);
    } else if (width <= 992) {
      setBeamLength(190);
    } else if (width <= 1200) {
      setBeamLength(220);
    } else if (width <= 1400) {
      setBeamLength(250);
    } else {
      setBeamLength(280);
    }
  };

  updateBeamLength();

  window.addEventListener("resize", updateBeamLength);

  return () => window.removeEventListener("resize", updateBeamLength);
}, []);

useEffect(() => {
    document.title =
      "About ONBBITS | WhatsApp Automation Experts";

    const metaDesc = document.querySelector("meta[name='description']");
    if (metaDesc) {
      metaDesc.setAttribute(
        "content",
        "Learn about ONBBITS, our mission and how we help businesses automate WhatsApp conversations, improve customer engagement and accelerate growth."
      );
    }

     const canonical = document.querySelector("link[rel='canonical']");
  if (canonical) {
    canonical.setAttribute("href", "https://onbbits.io/about-us");
  }

  const ogTitle = document.querySelector("meta[property='og:title']");
  if (ogTitle) {
    ogTitle.setAttribute(
      "content",
      "About ONBBITS | WhatsApp Automation Experts"
    );
  }

    const ogDesc = document.querySelector("meta[property='og:description']");
  if (ogDesc) {
    ogDesc.setAttribute(
      "content",
      "Learn about ONBBITS, our mission and how we help businesses automate WhatsApp conversations, improve customer engagement and accelerate growth."
    );
  }

  const ogUrl = document.querySelector("meta[property='og:url']");
  if (ogUrl) {
    ogUrl.setAttribute("content", "https://onbbits.io/about-us");
  }

    const ogImage = document.querySelector("meta[property='og:image']");
  if (ogImage) {
    ogImage.setAttribute(
      "content",
      "https://onbbits.io/Images/flow-builder.webp"
    );
  }

    const twitterTitle = document.querySelector("meta[name='twitter:title']");
  if (twitterTitle) {
    twitterTitle.setAttribute(
      "content",
      "About ONBBITS | WhatsApp Automation Experts"
    );
  }

    const twitterDesc = document.querySelector(
    "meta[name='twitter:description']"
  );
  if (twitterDesc) {
    twitterDesc.setAttribute(
      "content",
      "Learn about ONBBITS, our mission and how we help businesses automate WhatsApp conversations, improve customer engagement and accelerate growth."
    );
  }

    const twitterImage = document.querySelector("meta[name='twitter:image']");
  if (twitterImage) {
    twitterImage.setAttribute(
      "content",
      "https://onbbits.io/Images/flow-builder.webp"
    );
  }
  }, [])

const breadcrumbSchema = BreadcrumbSchema({
    items: [
      {
        name: "Home",
        url: "https://onbbits.io/"
      },
      {
        name: "About",
        url: "https://onbbits.io/about/"
      }
    ]
  });

    return(
        <>

      <SchemaMarkup data={OrganizationSchema} />
  <SchemaMarkup data={AboutPageSchema} />
  <SchemaMarkup data={breadcrumbSchema} />

        {/**BREADCRUMB */}
        <Breadcrumb title="Building the universal growth layer for businesses on WhatsApp" 
        description="From Tier-2/3 India to the world — ONBBITS empowers SMBs, enterprises and SaaS builders to automate and scale customer communication."
        large
        />

        {/**GROWTH ENGINE THAT LIVES INSIDE WHATSAPP SECTION */}
       <section className="growth-section container">

    <motion.div
        className="growth-left"
        variants={leftVariant}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.3 }}
    >

     <motion.h2
    className="section-heading"
    variants={child}
    whileInView={{
        scale:[.9,1.04,1]
    }}
    transition={{
        duration:1
    }}
>  
                A growth engine that lives <span>inside WhatsApp
            </span>
        </motion.h2>

       <motion.p
    className="special-text"
    variants={child}
    whileInView={{
        x:[-25,0],
        opacity:[0,1]
    }}
    transition={{
        duration:.9
    }}
>
            “Our vision is to build ONBBITS as the universal growth layer for
            businesses — enabling them to engage, convert and expand across every
            geography through WhatsApp.”
        </motion.p>

       <motion.p
    className="section-text"
    variants={child}
    whileInView={{
        opacity:[0,1],
        y:[40,0]
    }}
    transition={{
        duration:.9,
        delay:.2
    }}
>
            The platform your customers already use, transformed into an
            intelligent growth engine that captures every lead, responds
            instantly, automates follow-ups, and closes more deals—running
            24/7. From Tier-2/3 India to the world, ONBBITS empowers SMBs,
            enterprises, and SaaS builders to automate, manage, and scale
            customer communication effortlessly.
        </motion.p>

    </motion.div>

   <motion.div
    className="growth-right"
    variants={rightVariant}
    initial="hidden"
    whileInView="visible"
    viewport={{ once: true, amount: 0.3 }}
>

       <div className="engine-wrapper">
<div className="engine-bg"></div>
  <motion.div
    className="engine-glow"
    animate={{
        scale: [1, 1.25, 1],
        opacity: [0.25, 0.55, 0.25]
    }}
    transition={{
        duration: 1.3,
        repeat: Infinity,
        ease: "easeInOut"
    }}
/>

<div className="ray ray-top"></div>
<div className="ray ray-right"></div>

<motion.div
  className="laser laser-top"
  animate={{
    height: [0, beamLength, beamLength, 0, 0]
  }}
  transition={{
    duration: 10,
    times: [0, 0.08, 0.22, 0.28, 1],
    repeat: Infinity,
    ease: "linear"
  }}
/>

<motion.div
  className="laser laser-right"
  animate={{
    width: [0, 0, beamLength, beamLength, 0, 0]
  }}
  transition={{
    duration: 10,
    times: [0, 0.25, 0.33, 0.47, 0.53, 1],
    repeat: Infinity,
    ease: "linear"
  }}
/>

<motion.div
  className="laser laser-bottom"
  animate={{
    height: [0, 0,beamLength,beamLength, 0, 0]
  }}
  transition={{
    duration: 10,
    times: [0, 0.50, 0.58, 0.72, 0.78, 1],
    repeat: Infinity,
    ease: "linear"
  }}
/>


<motion.div
  className="laser laser-left"
  animate={{
    width: [0, 0, beamLength, beamLength, 0, 0]
  }}
  transition={{
    duration: 10,
    times: [0, 0.75, 0.83, 0.97, 1, 1],
    repeat: Infinity,
    ease: "linear"
  }}
/>

<motion.img
    src={engineIcon}
    alt=""
    className="engine-icon"
    animate={{
    scale:[1,1.06,1,1.03,1]
}}
   transition={{
    duration: 5,
    repeat: Infinity,
    ease: "easeInOut"
}}
/>

</div>
    </motion.div>

</section>

        {/**SIMPLIFY & SCALE CUSTOMER COMMUNICATION SECTION */}
        <ScaleCustomerCommunication />

        {/**PROBLEM SOLUTION SECTION */}
        <ProblemSolution />

        {/**THE ONBBITS STORY SECTION */}
       <section className="story-section">

  <div className="container">

    <motion.div
      className="story-left"
      variants={imageVariant}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount: 0.3 }}
    >
      <div className="engine-wrapper">
<div className="engine-bg"></div>
  <motion.div
    className="engine-glow"
    animate={{
        scale: [1, 1.25, 1],
        opacity: [0.25, 0.55, 0.25]
    }}
    transition={{
        duration: 1.3,
        repeat: Infinity,
        ease: "easeInOut"
    }}
/>

<div className="ray ray-top"></div>
<div className="ray ray-right"></div>

<motion.div
  className="laser laser-top"
  animate={{
    height: [0, beamLength, beamLength, 0, 0]
  }}
  transition={{
    duration: 10,
    times: [0, 0.08, 0.22, 0.28, 1],
    repeat: Infinity,
    ease: "linear"
  }}
/>

<motion.div
  className="laser laser-right"
  animate={{
    width: [0, 0, beamLength, beamLength, 0, 0]
  }}
  transition={{
    duration: 10,
    times: [0, 0.25, 0.33, 0.47, 0.53, 1],
    repeat: Infinity,
    ease: "linear"
  }}
/>

<motion.div
  className="laser laser-bottom"
  animate={{
    height: [0, 0, beamLength, beamLength, 0, 0]
  }}
  transition={{
    duration: 10,
    times: [0, 0.50, 0.58, 0.72, 0.78, 1],
    repeat: Infinity,
    ease: "linear"
  }}
/>


<motion.div
  className="laser laser-left"
  animate={{
    width: [0, 0, beamLength, beamLength, 0, 0]
  }}
  transition={{
    duration: 10,
    times: [0, 0.75, 0.83, 0.97, 1, 1],
    repeat: Infinity,
    ease: "linear"
  }}
/>

<motion.img
    src={storyIcon}
    alt=""
    className="engine-icon"
    animate={{
    scale:[1,1.06,1,1.03,1]
}}
   transition={{
    duration: 5,
    repeat: Infinity,
    ease: "easeInOut"
}}
/>
</div>
    </motion.div>

    <motion.div
      className="story-right"
      variants={textContainer}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount: 0.3 }}
    >

      <motion.h2
        className="section-heading"
        variants={textItem}
      >
          The   <span>ONBBITS Story
        </span>
      </motion.h2>

      <motion.p
        className="section-text"
        variants={textItem}
      >
       When we first started working with SMBs, one challenge came up again and again: <strong>WhatsApp was full of leads, but conversions were slipping through the cracks.</strong> Businesses spent on ads and generated inquiries, yet still struggled to close — reminders were missed, follow-ups weren’t consistent, and conversations turned chaotic.
      </motion.p>

      <motion.p
        className="section-text"
        variants={textItem}
      >
That insight became the spark for ONBBITS. What began as a simple idea to fix WhatsApp follow-ups grew into a vision of helping businesses <strong>automate communication, streamline operations and build smarter sales processes</strong> — all inside the platform their customers already love.
      </motion.p>

        <motion.p
        className="section-text"
        variants={textItem}
      >
ONBBITS is more than software — it’s our response to a real problem we’ve lived and seen firsthand. We believe small and medium businesses deserve the same powerful automation that big companies enjoy. And our journey has just begun.
      </motion.p>

    </motion.div>

  </div>

</section>

        {/**TEAM SECTION */}
        {/*<Team />*/}

        <div style={{marginTop:"-80px"}}></div>

        {/**CTA SECTION */}
        <Cta />

        </>
    )
}
export default About;